import { render, staticRenderFns } from "./internal-movement-action-list.component.vue?vue&type=template&id=4b833ce4&scoped=true&"
import script from "./internal-movement-action-list.component.vue?vue&type=script&lang=ts&"
export * from "./internal-movement-action-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./internal-movement-action-list.component.vue?vue&type=style&index=0&id=4b833ce4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b833ce4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCol,VHover,VIcon,VRow,VTextarea,VTooltip})
